'use strict';

import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * repose sur une configuration :<br/>
 * data : indique l'objet qui porte les données du formulaire.<br/>
 * customValidation : permet de faire des validations coté front<br/>
 * onError : fonction appellée si une validation est en erreur,
 * onSucces :
 * url : permet de fournir l'url qui traitera la data en soumission
 * beforeSend : methode qui peut traiter la data avant l'envoie (pour modifier des champs calculés par exemple)
 *
 * A la soumission des data, vous pouvez tester $scope.submitting pour savoir si l'envoi est en cours (par afficher un tl-circular-loader par exemple). Si une soumission est en cours, une autre ne peut avoir lieu.
 */
ngModule.directive("tlValidatedForm", function ($http, $debounce, objectUtils, fieldUtils, $q, $rootScope) {
  return {
    restrict: "A",
    require: ["tlValidatedForm", "form"],
    scope: true,
    controllerAs: '$tlValidatedFormCtrl',
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0];
      $scope.$watch($attrs.tlValidatedForm, function (formConfig) {
        if (!formConfig) {
          return;
        }
        ctrl.setConfig(formConfig);
      });
      $el.submit(function () {
        $scope.$apply(function () {
          ctrl.submitForm();
        });
      });
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        config = null,
        // todo - $scope.submitting et submitting font doublon, a retravailler.
        submitting = false,
        submitted = false,
        done = false,
        fields = {},
        errors = [],
        warns = [],
        // errors with no field name
        globalErrors = [],
        globalWarns = [];
      ctrl.setConfig = function (_config) {
        // TODO: rename to initialize
        config = _config;
        fieldUtils.delegateFieldChange($element, function () {
          // tester $scope.$applyAsync pour résoudre les Error : [$rootScope:inprog] $apply already in progress que nous avons régulièrement ici
          $scope.$applyAsync(function () {
            performClientSideValidation();
          });
        });
      };

      // met à jour l'état suite à une demande de validation externe
      $rootScope.$on("tlValidatedField:validate", function () {
        console.log("receive tlValidatedField:validate");
        performClientSideValidation();
      });
      var getFormData = function getFormData() {
        if (config == null) {
          return null;
        }
        return _.isString(config.data) ? $scope[config.data] : _.isFunction(config.data) ? config.data() : config.data;
      };

      /**
       *
       * @returns {[]} un tableau avec les erreurs au format {
                          fieldName: fieldName,
                          type: 'required',
                          message: 'Champs requis',
                      }.
       Test pour cela les champs avec tl-required, puis passe à customValidation
        */
      var computeValidationErrors = function computeValidationErrors() {
        var data = getFormData();
        var errors = [];
        var validateField = function validateField(field) {
          var fieldName = field.name;

          // l'attribut de data qui permet d'accéder à la donnée (à utiliser si on a fourni un fieldPrefix dans la config et que le fieldName ne permet donc pas d'accéder à l'attribut)
          var fieldAttribute = field.controller.getFieldAttribute();
          var validation = field.controller.getValidation();
          if (validation.required && !validation.virtual) {
            // ATTENTION, l'utilisation directe du fieldName ne marche que si le champs à un tl-validated-field non composé (pas de chemin jusqu'au champs) - sinon obligé d'utiliser un tl-field-attribute qui donne exactement l'attibut du model
            var fieldData = _.get(data, fieldAttribute || fieldName);
            console.log('check has data for fieldName = ' + fieldName, field);
            console.log("data", data);
            console.log("field data (resultat du get data." + (fieldAttribute || fieldName) + ")", fieldData, fieldAttribute || fieldName);
            var hasNoData = _.isArray(fieldData) ? fieldData.length === 0 : fieldData == null || _.isString(fieldData) && fieldData.length === 0;
            if (hasNoData) {
              if (!config) {
                console.log('No config');
                return;
              }
              // on doit retirer le fieldPrefix de fieldName car il est rajouté dans la partie affichage
              if (config.fieldPrefix) {
                if (fieldName.indexOf(config.fieldPrefix) !== -1) {
                  fieldName = fieldName.substring(config.fieldPrefix.length);
                }
              }
              errors.push({
                fieldName: fieldName,
                type: 'required',
                message: 'Champs requis'
              });
              console.log('Erreur added. List of errors :', errors);
            }
          }
        };
        _.each(fields, validateField);
        if (config && config.frontValidation) {
          // retro-compat, ancien nom
          console.warn("Migration : Use 'customValidation' instead of 'frontValidation'");
          errors = [].concat(_toConsumableArray(errors), _toConsumableArray(config.frontValidation()));
        }
        if (config && config.customValidation) {
          // nouveau nom
          errors = [].concat(_toConsumableArray(errors), _toConsumableArray(config.customValidation()));
        }
        return errors;
      };
      var performClientSideValidation = function performClientSideValidation() {
        ctrl.hideErrors();
        var errors = computeValidationErrors();
        if (errors.length > 0) {
          ctrl.showErrors(errors);
        }
        return errors;
      };
      var applyServerSideValidation = function applyServerSideValidation(validation) {
        var errors = validation.errors,
          warns = validation.warns;
        // TODO
      };
      ctrl.submitForm = function () {
        submitted = true;
        if (submitting || done) {
          console.log('soumission du formulaire déjà en cours');
          return;
        }
        if ($scope.submitting) {
          // soumission dejà en cours
          console.log("submission déjà en cours... ne ressoumet pas");
          return;
        }

        // client validation before posting
        var errors = performClientSideValidation();
        if (errors.length > 0) {
          config.onError && config.onError(errors);
          return;
        }
        var data = getFormData();
        var url = _.result(config, "url");
        if (config.beforeSend) {
          config.beforeSend(data);
        }

        /**
         * permet d'inquer une promise appellée avant la soumission (ex: message de confirmation)
         * @returns {*}
         */
        var beforePromiseAsync = function beforePromiseAsync(data) {
          var defered = $q.defer();
          if (!config.beforeSendAsync) {
            // promise vide
            return $q.resolve();
          } else {
            return config.beforeSendAsync(data);
          }
        };
        beforePromiseAsync(data).then(function () {
          $scope.submitting = true;
          $http.post(url, data).then(function (response) {
            var validation = response.data;
            if (validation == null || validation === "") {
              console.error('pas de response.data fourni par la resource pour', url, data, response);
            } else {
              if (validation.valid === null) {
                console.error('pas de response.data.valid fourni par la resource pour', url, data, response);
              }
            }
            ctrl.hideErrors();
            if (validation.valid) {
              config.onSuccess && config.onSuccess(validation.result);
              if (!config.allowResubmit) {
                done = true;
              }
            } else {
              ctrl.showErrors(validation.errors);
              ctrl.showWarns(validation.warns);
              config.onError && config.onError(validation.errors);
            }
            $scope.submitting = false;
          }, function (error) {
            $scope.submitting = false;
          });
        });
      };
      ctrl.hideErrors = function () {
        errors = [];
        globalErrors = [];
        _.each(fields, function (field, fieldName) {
          field.error = null;
        });
      };
      ctrl.hideWarns = function () {
        warns = [];
        globalWarns = [];
        _.each(fields, function (field, fieldName) {
          field.warn = null;
        });
      };
      ctrl.isSubmitting = function () {
        return submitting;
      };
      ctrl.isSubmitted = function () {
        return submitted;
      };
      ctrl.showErrors = function (_errors) {
        errors = _errors;
        _.each(errors, function (error) {
          if (error.fieldName == null) {
            globalErrors.push(error);
          } else {
            var fieldName = (config.fieldPrefix || "") + error.fieldName;
            if (fields[fieldName]) {
              fields[fieldName].error = error;
            } else {
              console.debug('Cannot find field ' + fieldName + ' in fields', fields);
            }
          }
        });
      };
      ctrl.showWarns = function (_warns) {
        warns = _warns;
        _.each(warns, function (warn) {
          if (warn.fieldName == null) {
            globalErrors.push(warn);
          } else {
            var fieldName = (config.fieldPrefix || "") + warn.fieldName;
            if (fields[fieldName]) {
              fields[fieldName].warn = warn;
            }
          }
        });
      };
      var delayedClientValidation = $debounce(performClientSideValidation, 50);
      ctrl.registerField = function (fieldName, fieldController) {
        fields[fieldName] = {
          name: fieldName,
          controller: fieldController,
          error: null,
          warn: null
        };
        delayedClientValidation();
        return fields[fieldName];
      };
      ctrl.unregisterField = function (fieldName) {
        delete fields[fieldName];
        delayedClientValidation();
      };
      ctrl.globalErrors = function () {
        return globalErrors;
      };
      ctrl.globalWarns = function () {
        return globalWarns;
      };
    }
  };
});

/**
 * Necessite d'avoir en parent un form avec tlValidatedForm<br/>
 * directive à placer sur chaque champs d'input qui necessite une validation (champs : input, select, textarea, .tl-checkbox, .tl-select, .tl-select-kind-field)<br/>
 * tlValidatedField : le nom fourni est celui du champs à valider en entier au sein de l'objet.<br/>
 * tlFieldAttribute : permet de donner l'attribut accesseur sur data si tlValidatedField ne le permet pas directement (forme x.y.z)
 * ajouter un tlRequired, pour rendre le champs obligatoire (validation front). Vous pouvez également mettre un 'tlValidatedFieldCheckIcon' sur l'element qui montrera le caractère obligatoire et l'état.
 */
ngModule.directive("tlValidatedField", function ($translate, fieldUtils, $rootScope) {
  // .tl-validated-input permet de définir directement un champs "custom" qui recevra la tooltip d'erreur et la couleur d'erreur
  var inputSelector = ".tl-validated-input, input, select, textarea, .tl-checkbox, .tl-select, .tl-select-kind-field";
  return {
    restrict: "A",
    require: ["tlValidatedField", "^tlValidatedForm"],
    scope: true,
    link: function link($scope, $el, $attrs, controllers) {
      var fieldController = controllers[0],
        formController = controllers[1];
      fieldController.initialize(formController);
    },
    controller: function controller($scope, $element, $attrs) {
      var ctrl = this;
      var state = {
        valid: true,
        untouched: true,
        error: null,
        warning: null
      };
      ctrl.initialize = function (formController) {
        var fieldName = $attrs.tlValidatedField;
        var field = formController.registerField(fieldName, ctrl);
        console.log('initializing ' + fieldName, field);

        // met à jour l'état suite à une demande de validation externe, pour que le untouched passe à false et que le champs soit du coup bien revalidé
        $rootScope.$on("tlValidatedField:validate", function () {
          // le champs doit etre vu comme ayant été "touché"
          state.untouched = false;
          applyState();
        });
        $scope.$watch(function () {
          return {
            error: field.error,
            warning: field.warn,
            submitted: formController.isSubmitted()
          };
        }, function (_ref) {
          var error = _ref.error,
            warning = _ref.warning,
            submitted = _ref.submitted;
          state.error = error;
          state.warning = warning;
          state.valid = !error && !warning;
          if (submitted) {
            state.untouched = false;
          }
          applyState();
        }, true);
        fieldUtils.delegateFieldBlur($element, function () {
          // tester $scope.$applyAsync pour résoudre les Error : [$rootScope:inprog] $apply already in progress que nous avons régulièrement ici
          $scope.$applyAsync(function () {
            state.untouched = false;
            applyState();
          });
        });
        $scope.$on("$destroy", function () {
          formController.unregisterField(fieldName);
        });
      };
      var isRequired = function isRequired() {
        return _.has($attrs, 'tlRequired') && $attrs.tlRequired !== 'false';
      };
      var isVirtual = function isVirtual() {
        return _.has($attrs, 'tlVirtual') && $attrs.tlVirtual !== 'false';
      };

      /**
       * attribut qui peut etre appelé directement sur la data pour récupérer sa valeur peut etre de la forme x.y.z
       * @returns {*}
       */
      ctrl.getFieldAttribute = function () {
        return $attrs.tlFieldAttribute;
      };
      ctrl.getFieldName = function () {
        return $attrs.tlValidatedField;
      };

      /** Retrieve the inline (from dom) validation of the field */
      ctrl.getValidation = function () {
        return {
          required: isRequired(),
          virtual: isVirtual()
        };
      };

      /** Returns true if the field is valid, false otherwise */
      ctrl.isValid = function () {
        return state.valid;
      };
      /** Returns true if the field is valid, false otherwise */
      ctrl.isUntouched = function () {
        return state.untouched;
      };
      /** Returns true if the field is required, false otherwise */
      ctrl.isRequired = function () {
        return isRequired();
      };
      var applyState = function applyState() {
        hideError();
        hideWarn();
        if (state.error && !state.untouched) {
          showError(state.error);
        }
        if (state.warning && !state.untouched) {
          showWarn(state.warning);
        }
      };
      var showError = function showError(error) {
        $element.addClass("has-error");
        var input = $element.find(inputSelector).first();
        // scroll si nécessaire pour rendre visible le champs
        if (!isInViewport(input[0])) {
          input[0].scrollIntoView({
            block: "start",
            inline: "nearest",
            behavior: "smooth"
          });
        }
        input.qtip({
          content: {
            text: error.message || $translate(error.messageKey, error.params)
          },
          position: {
            container: $element.closest("form"),
            my: 'middle left',
            at: 'middle right',
            adjust: {
              x: 3
            }
          },
          style: {
            classes: 'qtip-error'
          }
        });
      };
      function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
      }
      var hideError = function hideError() {
        $element.removeClass("has-error");
        var input = $element.find(inputSelector);
        input.qtip("destroy", true);
      };
      var showWarn = function showWarn(warn) {
        $element.addClass("has-warn");
        var input = $element.find(inputSelector);
        input.qtip({
          content: {
            text: warn.message || $translate(warn.messageKey, error.params)
          },
          position: {
            container: $element.closest("form"),
            my: 'middle left',
            at: 'middle right',
            adjust: {
              x: 3
            }
          },
          style: {
            classes: 'qtip-warn'
          }
        });
      };
      var hideWarn = function hideWarn() {
        $element.removeClass("has-warn");
        var input = $element.find("input, select, textarea, .tl-checkbox");
        input.qtip("destroy", true);
      };
    }
  };
});

/**
 * Pour montrer l'état de validation
 */
ngModule.directive("tlValidatedFieldCheckIcon", function () {
  return {
    restrict: "E",
    require: "^tlValidatedField",
    replace: true,
    scope: {},
    template: "<i tl-tooltip ng-show=\"state !== 'hidden' \" class=\"tl-field-check-icon {{getIconClass()}}\"></i>",
    link: function link($scope, $el, $attrs, fieldController) {
      $scope.state = 'hidden'; // hidden | required | valid | error

      $scope.getIconClass = function () {
        switch ($scope.state) {
          case 'required':
            return 'fas fa-asterisk required';
          case 'valid':
            return 'fas fa-check valid';
          case 'error':
            return 'fad fa-exclamation-triangle error';
          default:
            return '';
        }
      };
      $scope.getFieldName = function () {
        return fieldController.getFieldName();
      };
      $scope.$watch(function () {
        return {
          valid: fieldController.isValid(),
          untouched: fieldController.isUntouched(),
          required: fieldController.isRequired()
        };
      }, function (_ref2) {
        var valid = _ref2.valid,
          untouched = _ref2.untouched,
          required = _ref2.required;
        if (required) {
          if (valid) {
            $scope.state = 'valid';
          } else {
            $scope.state = untouched ? 'required' : 'error';
          }
        } else {
          $scope.state = !valid ? 'error' : 'hidden';
        }
        $scope.untouched = untouched;
      }, true);
    }
  };
});

/**
 * Permet d'afficher les erreurs sans champs indiqué.
 */
ngModule.directive("tlValidatedGlobalErrors", function ($translate) {
  return {
    restrict: "A",
    require: "^tlValidatedForm",
    scope: true,
    link: function link($scope, $el, $attrs, formController) {
      $scope.$watch(function () {
        return formController.globalErrors();
      }, function (globalErrors) {
        if (globalErrors != null && globalErrors.length > 0) {
          showError(globalErrors);
        } else {
          hideError();
        }
      });

      // validation

      var showError = function showError(globalErrors) {
        $el.addClass("has-error");
        $el.addClass("global-errors");
        // clean current messages
        $el.html("");
        _.each(globalErrors, function (error) {
          var msg;
          if (error.message) {
            msg = error.message;
          } else {
            msg = $translate(error.messageKey);
          }
          $el.append('<div>' + msg + '</div>');
        });
      };
      var hideError = function hideError() {
        $el.removeClass("has-error");
        $el.removeClass("global-errors");
        $el.html("");
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form/tlValidatedForm.js
// module id = 2954
// module chunks = 13